<mat-form-field class="input-container" [formGroup]="group" >
  <!-- Chiplist Component -->
  <mat-label>{{label}}</mat-label>
  <mat-chip-list #chipList aria-orientation="vertical">
    <mat-chip *ngIf="selected" [selectable]="true" [removable]="true" (removed)="removeChip()">
      {{selected}}
      <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
    </mat-chip>
    <!-- Input ELement -->
    <input #inputELement type="text" [ngClass]="{'input':selected}" matInput
            [id]="id"
            [formControl]="control"
            [placeholder]="placeHolder"
            (input)="onInputFunc($event.target.value)"
            (focus)="onInputFunc($event.target.value)"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList" autocomplete="off" required>
    <!-- <mat-icon [svgIcon]="icon" matSuffix></mat-icon> -->
  </mat-chip-list>
  <span class="error-message" *ngIf="control?.hasError('required') && control.touched">{{fieldRequired}}</span>
  <span class="error-message" *ngIf="getNgoError() && !control?.hasError('required')">NGO not found</span>
  <!-- Auto Complete component -->
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let option of filter | async"
                [value]="option.label"
                (onSelectionChange)="selectChange($event, option)"
                [hidden]="control?.value?.length === 0">
                {{option.label.trim()}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
